var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vux-alert" },
    [
      _c(
        "x-dialog",
        {
          attrs: {
            "mask-transition": _vm.maskTransition,
            "dialog-transition": _vm.dialogTransition,
            "hide-on-blur": _vm.hideOnBlur,
            "mask-z-index": _vm.maskZIndex
          },
          on: {
            "on-hide": function($event) {
              return _vm.$emit("on-hide")
            },
            "on-show": function($event) {
              return _vm.$emit("on-show")
            }
          },
          model: {
            value: _vm.showValue,
            callback: function($$v) {
              _vm.showValue = $$v
            },
            expression: "showValue"
          }
        },
        [
          _c("div", { staticClass: "weui-dialog__hd" }, [
            _c("strong", { staticClass: "weui-dialog__title" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "weui-dialog__bd" },
            [
              _vm._t("default", [
                _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "weui-dialog__ft" }, [
            _c(
              "a",
              {
                staticClass: "weui-dialog__btn weui-dialog__btn_primary",
                attrs: { href: "javascript:;" },
                on: { click: _vm._onHide }
              },
              [_vm._v(_vm._s(_vm.buttonText || "确定"))]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-570115ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-570115ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
// module id = null
// module chunks = 